import { Main } from './components/containers';

export const Incidents = () => {
  return <Main />;
};
